export const authorOptions = [
    "https://facefusion.site",
    "https://xueshu.fun",
    "https://aifun.fans",
    "https://localai.top",
    "https://sideincome.online",
    "https://patreon.com/localai",
    "https://patreon.com/UncensoredAI123"
];

export default authorOptions;
